/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { useReportExport } from "../../../hooks/useReportExport";

/**
 * The Daily Logbook's export runner. Nothing about it is report-specific, so it is the shared
 * hook under this report's name; the name is kept so the page reads the way the others do.
 */
export const useDailyLogbookExport = useReportExport;
